<template>
  <div>
    <h2 class="blind">구매/충전내역</h2>
    <span class="gray-text">이마티콘 충전내역을 확인하실 수 있습니다.</span>
    <div class="category-box">
      <select v-if="cardList.length === 1" v-model="prepaidCardNo" @change="getPrepaidCardReloadDetail">
        <option v-for="(item, index) in cardList" :key="index" :value="item.prepaidCardNo">{{item.prepaidCardNickName}} </option>
      </select>
      <button v-if="cardList.length > 1" type="button" class="menu-button" v-on:click="handlerClickSelect"><span>{{prepaidCardNickName}}</span></button>
      <order-select v-if="isSelect" :cardList="cardList" @select-card="selectPrepaidCard"></order-select>
    </div>
    <ul class="mydetail-button-list">
      <li><button :class="{'focus' : selectPeriod === '1month'}" @click.prevent="selectPeriod = '1month'">1개월</button><h2 class="blind" v-if="selectPeriod === '1month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === '3month'}" @click.prevent="selectPeriod = '3month'">3개월</button><h2 class="blind" v-if="selectPeriod === '3month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === '6month'}" @click.prevent="selectPeriod = '6month'">6개월</button><h2 class="blind" v-if="selectPeriod === '6month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === 'select'}" @click.prevent="selectPeriod = 'select'">기간조회</button><h2 class="blind" v-if="selectPeriod === 'select'">선택됨</h2></li>
    </ul>
    <h2 class="blind">{{selectPeriodText}}</h2>
    <div class="usage-date-box" v-if="selectPeriod==='select'">
      <input type="date" name="firstDate" v-model="startDate" data-placeholder="시작일" @change="validPeriod" required/>
      <input type="date" name="lastDate" v-model="lastDate" data-placeholder="종료일" @change="validPeriod" required/>
      <button type="button" @click.prevent="searchPeriod">검색</button>
    </div>
    <div class="usage-gray-box">
      <div>
        <span>총 충전 금액</span>
        <em>{{reloadSum | comma}}</em>
      </div>
    </div>
    <use-history :list-data="chargeListData" :type="'charge'" @charge-popup="chargeCancelPopup" @moveToRefund="moveToRefund" @toggleReceiptPopup="toggleReceiptPopup"></use-history>

    <my-detail-charge-cancel-popup v-if="cancelPopup" :data="chargeData" @charge-popup="chargeCancelPopup"></my-detail-charge-cancel-popup>
    <my-detail-charge-cancel-confirm-popup v-if="cancelConfirmPopup" :data="chargeData" @charge-popup="chargeCancelPopup"></my-detail-charge-cancel-confirm-popup>
    <alert-popup v-if="alertPopupShow" :message="alertMessage" @confirmPopupClickConfirm="alertPopupShow = false"></alert-popup>
    <receipt-popup v-if="showReceiptPopup" :receiptUrl="receiptUrl" @toggleReceiptPopup="toggleReceiptPopup"></receipt-popup>
    <pagination
        :totalRows="chargeListTotalRow"
        :pageModel="pageModel"
        v-on:movePage="movePage"
    />
  </div>
</template>

<script>
import UseHistory from '@/components/common/UseHistory.vue';
import dayjs from "dayjs";
import apiList from "@/api/apiList";
import MyDetailChargeCancelPopup from "@/views/myemarticon/mydetail/myDetailChargeCancelPopup";
import MyDetailChargeCancelConfirmPopup from "@/views/myemarticon/mydetail/myDetailChargeCancelConfirmPopup";
import AlertPopup from "@/views/myemarticon/alertPopup";
import Pagination from "@/components/common/Pagination";
import OrderSelect from "@/components/common/OrderSelect";
import ReceiptPopup from "@/views/myemarticon/mydetail/receiptPopup.vue";

export default {
  name: "myDetailCharge",
  components: {MyDetailChargeCancelConfirmPopup, MyDetailChargeCancelPopup, UseHistory, AlertPopup, Pagination, OrderSelect, ReceiptPopup },
  data() {
    return {
      cardList: [],
      prepaidCardNo: '',
      selectPeriodText: '1개월', //웹접근성
      selectPeriod: '1month',
      startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      lastDate: dayjs().format('YYYY-MM-DD'),
      reloadSum: 0,
      // 충전내역 데이터
      chargeListData: [
      ],
      pageModel: {
        size: 5,
        pageNo: 1
      },
      chargeListTotalRow: 0,
      cancelPopup: false,
      cancelConfirmPopup: false,
      chargeData: {},
      alertMessage: "",
      alertPopupShow: false,
      isSelect: false,
      prepaidCardNickName: '전체',
      showReceiptPopup: false,
      receiptUrl: '',
    }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    selectPeriod(value) {
      switch (value) {
        case '1month' :
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '1개월';
          break;
        case '3month' :
          this.startDate = dayjs().subtract(3, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '3개월';
          break;
        case '6month' :
          this.startDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '6개월';
          break;
        case 'select' :
          this.startDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '기간조회';
          break;
        default:
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '1개월';
      }
      this.pageModel.pageNo = 1;
      this.chargeListData = [];
      this.getPrepaidCardReloadDetail();
    }
  },
  mounted() {
    this.getPrepaidCardList();
    window.addEventListener("scroll", this.scrollPaging); //scroll 페이징
  },
  methods: {
    async getPrepaidCardList() {
      try{
        let param = {
          status: '',
        }
        const response = await apiList.getPrePaidCardBoxList(param); //카드 보관함 조회
        if(response.data.data) {
          this.cardList = response.data.data
        }
        this.cardList.unshift({prepaidCardNickName:'전체', prepaidCardNo:''});
        this.getPrepaidCardReloadDetail(); // 내역 호출 시점 변경

      } catch (error) {
        console.error(error);
      }
    },
    async getPrepaidCardReloadDetail() {

      try{
        const param = {
          startDate: this.startDate,
          endDate: this.lastDate,
          size: this.pageModel.size,
          pageNo: this.pageModel.pageNo,
          prepaidCardNo: this.prepaidCardNo
        };

        (!param.prepaidCardNo) && delete param.prepaidCardNo;

        const response = await apiList.getPrepaidReloadDetail(param);
        this.reloadSum = response.data.data.reloadSum;
        this.chargeListTotalRow =  response.data.data.reloadDetails? response.data.data.reloadDetails.totalRows : 0;
        this.prepaidCardReloadDetailList(response.data.data.reloadDetails? response.data.data.reloadDetails.list : []);

      } catch (error) {
        console.error(error);
      }
    },
    prepaidCardReloadDetailList(list) {
      this.chargeListData = [];
      for(let data of list) {

        if(data.paymentReason === 'RELOAD') {
          data.paymentReasonName = '수동충전';
        }
        //선불카드 상태 체크 로직
        let cardInfo = this.cardList.filter(item => {
              if(item.prepaidCardNo === data.prepaidCardNo) {
                return item;
              }
            }
        )

        if(data.cashCode === 'PROMOTIONCASH') { //증정상품권 전용 충전 리스트
          const param = {
            text: data.promotionalEventName + '(' + data.merchantName + ')',
            price: data.paymentReason === 'RELOAD_VOID'? '-'+data.cashAmount:data.cashAmount,
            firstDate: dayjs(data.transactionDateTime).format('YYYY/MM/DD'),
            lastDate: dayjs(data.transactionDateTime).format('HH:mm'),
            imageName: data.thumbnailImageUrl,
            imageAlt: data.thumbnailImageDesc,
            paymentReason: data.paymentReason,
            prepaidCardNo: data.prepaidCardNo,
            status: data.status
          }
          this.chargeListData.push(param);
        } else {
          const param = {
            // text: data.voided? (data.status === 'REVERSAL'? data.paymentReasonName+'[구매취소]':data.paymentReasonName+'[충전취소]'):(data.prepaidCardNo.substr(0, 6) != '321198'? data.paymentReasonName:cardInfo[0].prepaidCardNickName),
            text: data.voided? (data.status === 'REVERSAL'? data.paymentReasonName+'[구매취소]':data.paymentReasonName+'[충전취소]') : (data.cashCode != 'UNIVERSECASH'? data.paymentReasonName:cardInfo[0].prepaidCardNickName),
            price: data.voided? '-'+data.cashAmount:data.cashAmount,
            // firstDate: data.transactionDateTime,
            firstDate: dayjs(data.transactionDateTime).format('YYYY/MM/DD'),
            lastDate: dayjs(data.transactionDateTime).format('HH:mm'),
            imageName: data.thumbnailImageUrl,
            imageAlt: data.thumbnailImageDesc,
            popupImageName: data.imageUrl,
            paymentReason: data.paymentReason,
            // buttonText: data.prepaidCardNo.substr(0, 6) != '321198' ? (data.reloadRefundable? '환불': (data.reloadVoidable? '취소' : '')) : '',
            buttonText: data.cashCode != 'UNIVERSECASH' ? (data.reloadRefundable? '환불': (data.reloadVoidable? '취소' : '')) : '',
            prepaidCardNo: data.prepaidCardNo,
            cashNo: data.cashNo,
            orderNo: data.orderNo,
            requestId: this.$store.state.mberInfo.mberNo,
            ctmmnyNo: this.$store.state.partnerId,
            refundReason: 'cancel',
            receiptUrl: data.receiptUrl,
            status: data.status
          }
          this.chargeListData.push(param);
        }
      }
    },
    searchPeriod() {
      if(dayjs(this.lastDate).diff(dayjs(this.startDate), 'day') > 365) {
        this.alertPopupShow = true;
        this.alertMessage = '조회기간은 최대 12개월 입니다.';
        return;
      }

      if(!this.validPeriod()) {
        return;
      }
      this.chargeListData = [];
      this.pageModel.pageNo = 1;
      this.getPrepaidCardReloadDetail();
    },
    validPeriod() {
      if(this.startDate > this.lastDate) {
        this.alertPopupShow = true;
        this.alertMessage = '종료일이 시작일보다 이전일 수는 없습니다.';
        return false;
      }
      return true;
    },
    chargeCancelPopup([item, cancelPopup]) {
      if(item && cancelPopup) { //충전 취소 팝업 호출
        this.chargeData = item;
      } else if (item && !cancelPopup) { //충전 취소 팝업 완료 처리

        if(item.error) { //충전취소 실패
          this.chargeData.error = true;
          this.cancelConfirmPopup = true;
        } else { //충전취소 성공
          this.cancelConfirmPopup = true;
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD'); //기간 초기화
          this.lastDate = dayjs().format('YYYY-MM-DD'); //기간 초기화
          this.selectPeriod = '1month';
          this.chargeListData = []; //데이터 초기화
          this.pageModel.pageNo = 1; //페이지 초기화
          this.getPrepaidCardReloadDetail(); //충전이력 데이터 호출
        }
      } else { //충전 취소 완료 팝업 닫기
        this.cancelConfirmPopup = false;
      }
      this.cancelPopup = cancelPopup;
    },
    moveToRefund(item) {
      this.$router.push({name: 'refund', params: { cardInfo: item }});
    },
    movePage(pageNo) {
      this.pageModel.pageNo = pageNo;
      this.getPrepaidCardReloadDetail();
    },
    handlerClickSelect() {
      if(this.cardList.length > 1) {
        this.isSelect = !this.isSelect;
      }
    },
    selectPrepaidCard(item) {
      this.isSelect = false;
      this.prepaidCardNo = item.prepaidCardNo;
      this.prepaidCardNickName = item.prepaidCardNickName;
      this.useListData = [];
      this.pageModel.pageNo = 1;
      this.getPrepaidCardReloadDetail();
    },
    toggleReceiptPopup(receiptUrl) {
      this.showReceiptPopup = !this.showReceiptPopup
      if(this.showReceiptPopup) {
        this.receiptUrl = receiptUrl;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/styles/pages/myemarticon/myDetail.scss';
</style>